module.exports = __webpack_public_path__ + "media/images/registrations/product_version/bg-08-0b28a54cb271f4e7d8ec2655552426aa.png";